
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import {
  format,
  startOfWeek,
  endOfWeek,
  startOfTomorrow,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  addYears,
  addDays,
  addWeeks,
  addMonths,
  differenceInDays,
  getDay
} from 'date-fns';
import moment from 'moment';
import CalenderDays from '@/components/Filter/FilterComponents/CalenderDays.vue';
import {getDayDiffFromMonday, getStartDayOfWeek} from '@/util/calendar.js'

export default {
  props: {
    setdatefilter: {
      required: true,
      type: Function,
      default: () => {}
    },
    dateParentType: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      attrs: [
        {
          key: 'Holidays',
          highlight: true,
          popover: {
            label: ''
          },
          dates: []
        }
      ],
      retailCalendarMode: false,
      retailMonth: null,
      retailMonths: [],
      retailWeek: '',
      filterRetailWeeks: [],
      retailYear: null,
      monthList: [
        { label: this.$t('FilterBar.January'), value: 'Jan' },
        { label: this.$t('FilterBar.February'), value: 'Feb' },
        { label: this.$t('FilterBar.March'), value: 'Mar' },
        { label: this.$t('FilterBar.April'), value: 'Apr' },
        { label: this.$t('FilterBar.May'), value: 'May' },
        { label: this.$t('FilterBar.June'), value: 'Jun' },
        { label: this.$t('FilterBar.July'), value: 'Jul' },
        { label: this.$t('FilterBar.August'), value: 'Aug' },
        { label: this.$t('FilterBar.September'), value: 'Sep' },
        { label: this.$t('FilterBar.October'), value: 'Oct' },
        { label: this.$t('FilterBar.November'), value: 'Nov' },
        { label: this.$t('FilterBar.December'), value: 'Dec' }
      ],
      retailMonthsOptions: [
        { label: this.$t('FilterBar.January'), value: 'Jan' },
        { label: this.$t('FilterBar.February'), value: 'Feb' },
        { label: this.$t('FilterBar.March'), value: 'Mar' },
        { label: this.$t('FilterBar.April'), value: 'Apr' },
        { label: this.$t('FilterBar.May'), value: 'May' },
        { label: this.$t('FilterBar.June'), value: 'Jun' },
        { label: this.$t('FilterBar.July'), value: 'Jul' },
        { label: this.$t('FilterBar.August'), value: 'Aug' },
        { label: this.$t('FilterBar.September'), value: 'Sep' },
        { label: this.$t('FilterBar.October'), value: 'Oct' },
        { label: this.$t('FilterBar.November'), value: 'Nov' },
        { label: this.$t('FilterBar.December'), value: 'Dec' }
      ],
      retailMonthSelection: '',
      retailWeeks: [],
      retailYears: [],
      calenderMode: 'range',
      dragValue: null,
      selectedPeriodState: false,
      selectedDateRange: [],
      dateOptionsSelectedModel: {
        label: this.$store.state.user.translate.next_month,
        value: 'NEXT_MONTH'
      },
      dateOptionsComparedModel: {
        label: this.$t('DateRangeSelector.previous_year_same_period'),
        value: 'PREVIOUS_YEAR_SAME_PERIOD'
      },
      marketingCampaignMode: false,
      marketingCampaignOption: null,
      marketingCampaignOptionList: [],
      dateOptionsSelected: [
        {
          label: this.$store.state.user.translate.today,
          value: 'TODAY'
        },
        {
          label:this.$store.state.user.translate.tomorrow,
          value: 'TOMORROW'
        },
        {
          label: this.$store.state.user.translate.this_week,
          value: 'THIS_WEEK'
        },
        {
          label: this.$store.state.user.translate.next_week,
          value: 'NEXT_WEEK'
        },
        {
          label: this.$store.state.user.translate.this_month,
          value: 'THIS_MONTH'
        },
        {
          label: this.$store.state.user.translate.next_month,
          value: 'NEXT_MONTH'
        },
        {
          label: this.$store.state.user.translate.this_year,
          value: 'THIS_YEAR'
        },
        {
          label: this.$store.state.user.translate.next_year,
          value: 'NEXT_YEAR'
        }
      ],
      dateOptionsCompared: [
        {
          label: this.$t('DateRangeSelector.previous_period'),
          value: 'PREVIOUS_PERIOD'
        },
        {
          label: this.$t('DateRangeSelector.previous_year_same_period'),
          value: 'PREVIOUS_YEAR_SAME_PERIOD'
        },
        {
          label: this.$t('FilterBar.previous_year_same_day_of_week'),
          value: 'PREVIOUS_YEAR_SAME_DAY_OF_WEEK'
        }
        // {
        //   label: this.$t('DateRangeSelector.special_calendar'),
        //   value: 'tutuanna_calender'
        // }
      ],
      selectedPeriod: {
        start: new Date(), // Jan 16th, 2018
        end: new Date() // Jan 19th, 2018
      },
      comparedPeriod: {
        start: addDays(new Date(), -1), // Jan 16th, 2018
        end: addDays(new Date(), -1) // Jan 19th, 2018
      },
      lastTimeStamp: Date.now(),
      startDayFromMonday: 0,
      startDayOfWeek: 1,
    };
  }, // data
  computed: {
    ...mapState('user', ['profile', 'startOfWeek', "defaultSettings"]),
    ...mapGetters('user', ['getLocale']),
    ...mapState('filter', ['filter', 'retailCalendar', 'holidays']),
    ...mapState('store', ['stores']),
    ...mapState('comparison', ['marketingCampaign', 'compareDates']),
    // ...mapState('comparison', []),
    tutuannaMode() {
      return this.dateOptionsComparedModel.value === 'tutuanna_calender';
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: this.tutuannaMode ? 'hover' : 'none',
          isInteractive: false // Defaults to true when using slot
        }
      };
    },

    dragComparedValue: function() {
      let value = '';
      if (this.dragValue && this.compareDates) {
        value = this.getComparedDate(this.formatDate(this.dragValue));
        return this.formatDate(value);
      } else {
        return value;
      }
    },
    numberfRetailWeeks() {
      return this.retailCalendar?.find(
        v => v.label.toString() === this.retailYear.value.toString()
      )?.numberOfWeeks;
    },
    startDateOfRetailYear() {
      return this.retailCalendar?.find(
        v => v.label.toString() === this.retailYear?.value.toString()
      )?.startDate;
    }
  }, // computed
  watch: {
    retailYear() {
      let num = this.retailCalendar?.find(
        v => v.label.toString() === this.retailYear.value.toString()
      )?.numberOfWeeks;
      let startDateRetail = this.retailCalendar?.find(
        v => v.label.toString() === this.retailYear.value.toString()
      )?.startDate;
      this.retailMonthSelection = {
        label: this.$t(`FilterBar.${moment(startDateRetail).format('MMMM')}`),
        value: moment(startDateRetail).format('MMM')
      };

      let monthIndex = this.monthList.findIndex(
        v => v.value === this.retailMonthSelection.value
      );
      this.retailMonthsOptions = [
        ...this.monthList.slice(monthIndex, 12),
        ...this.monthList.slice(0, monthIndex)
      ];
      // this.retailMonthSelection = { label: this.$t('January'), value: 'Jan' };
      this.getRetailWeeks(startDateRetail, 12, num);
    },
    retailWeek() {
      if (
        new Date(this.retailWeek?.value?.startingPeriod) < new Date() &&
        new Date(this.retailWeek?.value?.endingPeriod) < new Date()
      ) {
        this.selectedPeriod = {}
        this.$set(this.selectedPeriod, "start", new Date(this.retailWeek?.value?.startingPeriod))
        this.$set(this.selectedPeriod, "end", new Date(this.retailWeek?.value?.endingPeriod))
      } else {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: `Please select range lower than present day`
        });
      }
    },
    retailMonth() {
      if (
        new Date(this.retailMonth?.value?.startingPeriod) < new Date() &&
        new Date(this.retailMonth?.value?.endingPeriod) < new Date()
      ) {
        this.selectedPeriod = {}
        this.$set(this.selectedPeriod, "start", new Date(this.retailMonth?.value?.startingPeriod))
        this.$set(this.selectedPeriod, "end", new Date(this.retailMonth?.value?.endingPeriod))
      } else {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: `Please select range lower than present day`
        });
      }
    },
    retailMonthSelection() {
      this.filterRetailWeeks = this.retailWeeks.filter(v =>
        v.label.includes(this.getSelectedMonth(this.retailMonthSelection.value))
      );
      this.retailWeek = this.filterRetailWeeks[0];
    },
    marketingCampaign() {
      if (this.marketingCampaign && this.marketingCampaign.length > 0) {
        this.dateOptionsSelected = [
          ...this.dateOptionsSelected
        ];
      }
    },
   
    holidays() {
      this.attrs = [
        ...this.holidays.map(v => ({
          key: 'Holidays',
          // highlight: true,
          popover: {
            label: v.value,
            labelClass: 'white-text',
            labelStyle: { color: 'white' },
            class: 'white-text'
          },
          dates: v.date,
          bar: {
            color: 'red',
            class: 'my-dot-class'
          }
        }))
      ];
    },
  
    selectedPeriod: function() {
      this.getSelectedDateRange();
      if (this.tutuannaMode) {
        this.comparedPeriod = this.selectedDateRange.map(
          dat => new Date(this.getComparedDate(dat))
        );
      } else {
        if (this.dateOptionsComparedModel.value === 'PREVIOUS_PERIOD') {
          const diffDays = differenceInDays(
            this.selectedPeriod.start,
            this.selectedPeriod.end
          );
          const diffDaysPositive =
            diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
          const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
          this.comparedPeriod.start = addWeeks(
            this.selectedPeriod.start,
            -weeks
          );
          this.comparedPeriod.end = addWeeks(this.selectedPeriod.end, -weeks);
        } else if (
          this.dateOptionsComparedModel.value === 'PREVIOUS_YEAR_SAME_PERIOD'
        ) {
          this.comparedPeriod.start = addYears(
            new Date(this.selectedPeriod.start),
            -1
          );
          this.comparedPeriod.end = addYears(
            new Date(this.selectedPeriod.end),
            -1
          );
        } else if (
          this.dateOptionsComparedModel.value ===
          'previous_year_same_day_of_week'
        ) {
          this.comparedPeriod.start = addWeeks(
            new Date(this.selectedPeriod.start),
            -52
          );
          this.comparedPeriod.end = addWeeks(
            new Date(this.selectedPeriod.end),
            -52
          );
        } else if (
          this.dateOptionsComparedModel.value === 'PREVIOUS_YEAR_SAME_WEEK'
        ) {
          // this.comparedPeriod= {}
          const prevYear =
            this.retailCalendar?.find(
              v =>
                v.label.toString() ===
                (
                  this.retailYear?.value ??
                  new Date(this.selectedPeriod.start).getFullYear() - 1
                ).toString()
            ) || null;
          const weeksToAdd = this.retailWeeks.findIndex(
            v => v === this.retailWeek
          );
          if (prevYear) {
            const startDateRetail = prevYear.startDate;
            const endOfStartDateRetail = moment(
              addDays(new Date(startDateRetail), 6)
            ).format('YYYY-MM-DD');
            // let startDateRetail = prevYear.startDate;

            this.comparedPeriod.start = addWeeks(
              new Date(startDateRetail),
              weeksToAdd
            );
            this.comparedPeriod.end = addWeeks(
              new Date(endOfStartDateRetail),
              weeksToAdd
            );
          } else {
            const currYear = this.retailCalendar?.find(
              v => v.label.toString() === this.retailYear.value.toString()
            );
            const startDateRetail = currYear.startDate;
            const endOfStartDateRetail = moment(
              addDays(new Date(startDateRetail), 6)
            ).format('YYYY-MM-DD');
            this.comparedPeriod.start = addWeeks(
              new Date(startDateRetail),
              weeksToAdd - 52
            );
            this.comparedPeriod.end = addWeeks(
              new Date(endOfStartDateRetail),
              weeksToAdd - 52
            );
          }
        } else if (
          this.dateOptionsComparedModel.value === 'previous_year_same_month'
        ) {
          let retailDetails =
            this.retailCalendar?.find(
              v => v.label.toString() === (this.retailYear.value - 1).toString()
            ) || null;
          if (retailDetails) {
            const prevYearMonths = this.getRetailMonths(
              retailDetails.startDate,
              12,
              retailDetails.numberOfWeeks
            );

            const currMonthIndex = this.retailMonths.findIndex(
              v => v === this.retailMonth
            );

            this.comparedPeriod.start = new Date(
              prevYearMonths[currMonthIndex]?.value?.startingPeriod
            );
            this.comparedPeriod.end = new Date(
              prevYearMonths[currMonthIndex]?.value?.endingPeriod
            );
          } else {
            this.comparedPeriod.start = addYears(this.selectedPeriod.start, -1);
            this.comparedPeriod.end = addYears(this.selectedPeriod.end, -1);
          }
        }
      }
    },
    dateOptionsSelectedModel(val) {
        console.log('dateOptionsSelectedModel(val)',val);
    console.log('this.tutuannaMode',this.tutuannaMode);
      this.getSelectedDateRange();
      if (this.tutuannaMode) {
        this.comparedPeriod = this.selectedDateRange.map(
          dat => new Date(this.getComparedDate(dat))
        );
      } else {
        if (this.dateOptionsComparedModel.value === 'PREVIOUS_PERIOD') {
          const diffDays = differenceInDays(
            this.selectedPeriod.start,
            this.selectedPeriod.end
          );
          const diffDaysPositive =
            diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
          const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
          this.comparedPeriod.start = addWeeks(
            this.selectedPeriod.start,
            -weeks
          );
          this.comparedPeriod.end = addWeeks(this.selectedPeriod.end, -weeks);
        } else if (
          this.dateOptionsComparedModel.value === 'PREVIOUS_YEAR_SAME_PERIOD'
        ) {
          this.comparedPeriod.start = addYears(
            new Date(this.selectedPeriod.start),
            -1
          );
          this.comparedPeriod.end = addYears(
            new Date(this.selectedPeriod.end),
            -1
          );
        } else if (
          this.dateOptionsComparedModel.value ===
          'previous_year_same_day_of_week'
        ) {
          this.comparedPeriod.start = addWeeks(
            new Date(this.selectedPeriod.start),
            -52
          );
          this.comparedPeriod.end = addWeeks(
            new Date(this.selectedPeriod.end),
            -52
          );
        }
      }
    },
    marketingCampaignOption: function() {
      if (!this.tutuannaMode && this.marketingCampaignMode) {
        if (this.dateOptionsComparedModel.value === 'PREVIOUS_PERIOD') {
          const diffDays = differenceInDays(
            this.selectedPeriod.start,
            this.selectedPeriod.end
          );
          const diffDaysPositive =
            diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
          const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
          this.comparedPeriod.start = addWeeks(
            this.selectedPeriod.start,
            -weeks
          );
          this.comparedPeriod.end = addWeeks(this.selectedPeriod.end, -weeks);
        } else if (
          this.dateOptionsComparedModel.value === 'PREVIOUS_YEAR_SAME_PERIOD'
        ) {
          this.comparedPeriod.start = addYears(
            new Date(this.selectedPeriod.start),
            -1
          );
          this.comparedPeriod.end = addYears(
            new Date(this.selectedPeriod.end),
            -1
          );
        } else if (
          this.dateOptionsComparedModel.value ===
          'previous_year_same_day_of_week'
        ) {
          this.comparedPeriod.start = addWeeks(
            new Date(this.selectedPeriod.start),
            -52
          );
          this.comparedPeriod.end = addWeeks(
            new Date(this.selectedPeriod.end),
            -52
          );
        }
      }
    }
  },
  async created() {
  //  this.firstTimeCheck()
    this.startDayFromMonday = getDayDiffFromMonday();
    this.startDayOfWeek = getStartDayOfWeek();
    if (this.retailCalendar.length > 0) {
      this.dateOptionsSelected = [
        ...this.dateOptionsSelected
      ];

      this.retailYears = await this.retailCalendar.map(v => ({
        label: v.label,
        value: v.label
      }));
      // this.getRetailWeeks(
      //   this.startDateOfRetailYear,
      //   12,
      //   this.numberfRetailWeeks
      // );

      // this.retailYear = {
      //   label: new Date().getFullYear(),
      //   value: '2020'
      // };
    }
    
    //this.selectedPeriod();
    this.$set(this.selectedPeriod, "start", new Date(this.filter.startingPeriodCal))
    this.$set(this.selectedPeriod, "end", new Date(this.filter.endingPeriodCal))
    this.$set(this.comparedPeriod, "start", new Date(this.filter.startingComparedCal))
    this.$set(this.comparedPeriod, "end", new Date(this.filter.endingComparedCal))
    
    /*this.dateOptionsSelected?.forEach((data) => {
     
      if (data.value == this.filter.selectedOption) {
        this.$set(this.dateOptionsSelectedModel, "value", data.value)
        this.$set(this.dateOptionsSelectedModel, "label", data.label)
        this.$set(this.dateOptionsSelectedModel, "disable", data.disable || false)
        this.dateOptionsSelectedModelChanged(data.value);
      }
    })*/
   /* this.dateOptionsCompared?.forEach((data) => {
      if (data.value == this.filter.comparedOption) {
        this.$set(this.dateOptionsComparedModel, "value", data.value)
        this.$set(this.dateOptionsComparedModel, "label", data.label)
        this.$set(this.dateOptionsComparedModel, "disable", data.disable || false)
        this.dateOptionsComparedModelChanged(data.value);
      }
    })*/
  /*  if(this.filter.selectedOption == "CUSTOM_RANGE" || this.filter.selectedOption == "CUSTOM") {
      this.onDayClick()
    }*/
 /*   if(this.filter.comparedOption == "CUSTOM") {
      this.onDayClickCompare()
    }*/
    await this.fetchHolidays();
    await this.fetchCompareDates();
    this.getSelectedDateRange();

    this.setCalendarDatesToStoreCal({selectedOption: this.dateOptionsSelectedModel.value, comparedOption: this.dateOptionsComparedModel.value, selectedPeriod: this.selectedPeriod, comparedPeriod: this.comparedPeriod})
     // this.submitDate()
  }, // created
  methods: {
    ...mapMutations('filter', [
      "setCalendarDatesToStoreCal",
      'setStartingPeriodCal',
      'setEndingPeriodCal',
      'setStartingComparedCal',
      'setEndingComparedCal',
      'setCustomCalenderFlag'
    ]), // mapMutations
    ...mapActions('comparison', [
      'fetchCompareDates'
    ]),
    ...mapActions('filter', ['fetchHolidays']),
    onDayClick() {
     
    },
    onDayClickCompare() {
     
    },
    getFormattedDate(date) {
      let retVal = date ? moment(new Date(date))?.format('YYYY/MM/DD') : "Invalid date";
      if(retVal.trim() == "Invalid date") {
        retVal = ""
      }
      return retVal;
    },
    getSelectedMonth(val) {
      if (val.includes('Jan')) return '/01/';
      else if (val.includes('Feb')) return '/02/';
      else if (val.includes('Mar')) return '/03/';
      else if (val.includes('Apr')) return '/04/';
      else if (val.includes('May')) return '/05/';
      else if (val.includes('Jun')) return '/06/';
      else if (val.includes('Jul')) return '/07/';
      else if (val.includes('Aug')) return '/08/';
      else if (val.includes('Sep')) return '/09/';
      else if (val.includes('Oct')) return '/10/';
      else if (val.includes('Nov')) return '/11/';
      else if (val.includes('Dec')) return '/12/';
    },
    getRetailMonths(startingDateVal, noOfMonths, noOfWeeks = 52) {
      let startingMonth = new Date(startingDateVal);
      let monthsVal = [];
      for (let i = 0; i < noOfMonths; i++) {
        let monthStart = moment(startingMonth).format('YYYY-MM-DD');
        let monthEnd = moment(
          addDays(addWeeks(startingMonth, (i + 1) % 3 === 0 ? 5 : 4), -1)
        ).format('YYYY-MM-DD');
        startingMonth = addWeeks(startingMonth, (i + 1) % 3 === 0 ? 5 : 4);
        monthsVal.push({
          label:
            moment(monthStart).format('YYYY/MM/DD') +
            ' - ' +
            moment(monthEnd).format('YYYY/MM/DD'),
          value: {
            startingPeriod: monthStart,
            endingPeriod: monthEnd
          }
        });
      }
      if (noOfWeeks === '53') {
        monthsVal[10].value.endingPeriod = moment(
          addWeeks(new Date(monthsVal[10].value.endingPeriod), 1)
        ).format('YYYY-MM-DD');
        monthsVal[10].label =
          monthsVal[10]?.value?.startingPeriod.replace('-', '/') +
          ' - ' +
          monthsVal[10]?.value?.endingPeriod.replace('-', '/');
        monthsVal[11].value.startingPeriod = moment(
          addWeeks(new Date(monthsVal[11].value.startingPeriod), 1)
        ).format('YYYY-MM-DD');
        monthsVal[11].value.endingPeriod = moment(
          addWeeks(new Date(monthsVal[11].value.endingPeriod), 1)
        ).format('YYYY-MM-DD');
        monthsVal[11].label =
          monthsVal[11].value?.startingPeriod.replace('-', '/') +
          ' - ' +
          monthsVal[11].value?.endingPeriod.replace('-', '/');
      }
      return monthsVal;
    },
    getRetailWeeks(startingDateVal, noOfMonths, noOfWeeks) {
      let startingDate = startingDateVal ? new Date(startingDateVal) : null;

      this.retailWeeks = [];
      this.retailMonths = this.getRetailMonths(
        startingDateVal,
        noOfMonths,
        noOfWeeks
      );
      this.retailMonth = startingDate ? this.retailMonths[0] : null;
      for (let i = 0; i < noOfWeeks; i++) {
        let weekStart = moment(startingDate).format('YYYY-MM-DD');
        let weekEnd = moment(addDays(addWeeks(startingDate, 1), -1)).format(
          'YYYY-MM-DD'
        );
        const weekVal = {
          label:
            moment(weekStart).format('YYYY/MM/DD') +
            ' - ' +
            moment(weekEnd).format('YYYY/MM/DD'),
          value: {
            startingPeriod: weekStart,
            endingPeriod: weekEnd
          }
        };
        startingDate = addWeeks(startingDate, 1);
        this.retailWeeks.push(weekVal);
      }
    },
    getSelectedDateRange() {
      let dates = [];
      let startDate = this.selectedPeriod.start;
      while (startDate <= this.selectedPeriod.end) {
        dates.push(startDate);
        startDate = addDays(startDate, 1);
      }
      this.selectedDateRange = dates.map(dat => this.formatDate(dat));
    },
    dateOptionsSelectedModelChanged() {
      const selectedOption = this.dateOptionsSelectedModel.value;
      this.marketingCampaignMode = false;
      this.retailCalendarMode = false;
      if (selectedOption === 'TODAY') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = new Date();
        this.selectedPeriod.end = new Date();
      } else if (selectedOption === 'TOMORROW') {
        this.selectedPeriod = {};
        const tomorrow = startOfTomorrow();
        this.selectedPeriod.start = tomorrow;
        this.selectedPeriod.end = tomorrow;
      } else if (selectedOption === 'THIS_WEEK') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = startOfWeek(new Date(), { weekStartsOn: this.startDayOfWeek });
        this.selectedPeriod.end = endOfWeek(new Date(), { weekStartsOn: this.startDayOfWeek });
        // this.selectedPeriod.end = endOfWeek(new Date());
      } else if (selectedOption === "NEXT_WEEK") {
        this.selectedPeriod = {};
        const d = addWeeks(new Date(), 1);
        this.selectedPeriod.start = startOfWeek(d, { weekStartsOn: this.startDayOfWeek });
        this.selectedPeriod.end = addDays(this.selectedPeriod.start, 6)
      } else if (selectedOption === 'THIS_MONTH') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = startOfMonth(new Date());
        this.selectedPeriod.end = endOfMonth(new Date());
        // this.selectedPeriod.end = endOfMonth(new Date());
      } else if (selectedOption === 'NEXT_MONTH') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = startOfMonth(addMonths(new Date(), 1));
        this.selectedPeriod.end = endOfMonth(addMonths(new Date(), 1));
      } else if (selectedOption === 'THIS_YEAR') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = startOfYear(new Date());
        this.selectedPeriod.end = endOfYear(new Date());
        // this.selectedPeriod.end = endOfYear(new Date());
      } else if (selectedOption === 'NEXT_YEAR') {
        this.selectedPeriod = {};
        this.selectedPeriod.start = addYears(startOfYear(new Date()), 1);
        this.selectedPeriod.end = addYears(endOfYear(new Date()), 1);
      } else if (selectedOption === 'marketing_campaigns') {
        this.marketingCampaignMode = true;
      } else if (selectedOption === 'retail_calendar') {
        this.retailCalendarMode = true;
      } else if (selectedOption === 'retail_calendar_monthly') {
        this.retailCalendarMode = true;
      }
      this.dateOptionsComparedModelChanged();
    },
    dateOptionsComparedModelChanged() {
      this.specialCalenderMode = false;
      // const selectedOption = this.dateOptionsSelectedModel.value;
      const comparedOption = this.dateOptionsComparedModel.value;
      this.calenderMode = 'range';
      if (comparedOption === 'PREVIOUS_PERIOD') {
        this.comparedPeriod = {};

        const diffDays = differenceInDays(
          this.selectedPeriod.start,
          this.selectedPeriod.end
        );
        const diffDaysPositive =
          diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
        const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
        this.comparedPeriod.start = addWeeks(this.selectedPeriod.start, -weeks);
        this.comparedPeriod.end = addWeeks(this.selectedPeriod.end, -weeks);
      } else if (comparedOption === 'PREVIOUS_YEAR_SAME_PERIOD') {
        this.comparedPeriod = {};
        this.comparedPeriod.start = addYears(new Date(), -1);
        this.comparedPeriod.end = addYears(new Date(), -1);
        const diffDays = differenceInDays(
          this.selectedPeriod.start,
          this.selectedPeriod.end
        );
        this.comparedPeriod.start = addYears(this.selectedPeriod.start, -1);
        this.comparedPeriod.end = addYears(this.selectedPeriod.end, -1);
      } else if (comparedOption === 'PREVIOUS_YEAR_SAME_DAY_OF_WEEK') {
        this.comparedPeriod = {};
        this.comparedPeriod.start = addWeeks(
          new Date(this.selectedPeriod.start),
          -52
        );
        this.comparedPeriod.end = addWeeks(
          new Date(this.selectedPeriod.end),
          -52
        );
      } else if (comparedOption === 'PREVIOUS_YEAR_SAME_WEEK') {
        this.comparedPeriod= {}
        const prevYear =
          this.retailCalendar?.find(
            v =>
              v.label.toString() ===
              (
                this.retailYear?.value ??
                new Date(this.selectedPeriod.start).getFullYear() - 1
              ).toString()
          ) || null;
        const weeksToAdd = this.retailWeeks.findIndex(
          v => v === this.retailWeek
        );
        if (prevYear) {
          const startDateRetail = prevYear.startDate;
          const endOfStartDateRetail = moment(
            addDays(new Date(startDateRetail), 6)
          ).format('YYYY-MM-DD');
          // let startDateRetail = prevYear.startDate;

          this.comparedPeriod.start = addWeeks(
            new Date(startDateRetail),
            weeksToAdd
          );
          this.comparedPeriod.end = addWeeks(
            new Date(endOfStartDateRetail),
            weeksToAdd
          );
        } else {
          const currYear = this.retailCalendar?.find(
            v => v.label.toString() === this.retailYear.value.toString()
          );
          const startDateRetail = currYear.startDate;
          const endOfStartDateRetail = moment(
            addDays(new Date(startDateRetail), 6)
          ).format('YYYY-MM-DD');
          this.comparedPeriod.start = addWeeks(
            new Date(startDateRetail),
            weeksToAdd - 52
          );
          this.comparedPeriod.end = addWeeks(
            new Date(endOfStartDateRetail),
            weeksToAdd - 52
          );
        }
      } else if (comparedOption === 'previous_year_same_month') {
        this.comparedPeriod = {};
        let retailDetails =
          this.retailCalendar?.find(
            v => v.label.toString() === (this.retailYear.value - 1).toString()
          ) || null;
        if (retailDetails) {
          const prevYearMonths = this.getRetailMonths(
            retailDetails.startDate,
            12,
            retailDetails.numberOfWeeks
          );

          const currMonthIndex = this.retailMonths.findIndex(
            v => v === this.retailMonth
          );

          this.comparedPeriod.start = new Date(
            prevYearMonths[currMonthIndex]?.value?.startingPeriod
          );
          this.comparedPeriod.end = new Date(
            prevYearMonths[currMonthIndex]?.value?.endingPeriod
          );
        } else {
          this.comparedPeriod.start = addYears(this.selectedPeriod.start, -1);
          this.comparedPeriod.end = addYears(this.selectedPeriod.end, -1);
        }
      } else if (comparedOption === 'tutuanna_calender') {
        this.specialCalenderMode = true;
        this.calenderMode = 'multiple';
        this.getComparedDatesArray();
      }
    },
    getComparedDatesArray() {
      this.comparedPeriod = {};
      this.comparedPeriod = this.selectedDateRange.map(
        dat => new Date(this.getComparedDate(dat))
      );
    },
    marketingCampaignOptionChange() {
      let val = this.marketingCampaignOption.value;
      this.selectedPeriod = {};
      this.selectedPeriod = {
        start: new Date(val.startDate),
        end: new Date(val.endDate)
      };
    },
    startingPeriodChanged(val) {
      this.setStartingPeriodCal({ startingPeriodCal: val });
    }, // startingPeriodChanged
    endingPeriodChanged(val) {
      this.setEndingPeriodCal({ endingPeriodCal: val });
    }, // endingPeriodChanged
    startingComparedChanged(val) {
      this.setStartingComparedCal({ startingComparedCal: val });
    }, // startingComparedChanged
    endingComparedChanged(val) {
      this.setEndingComparedCal({ endingComparedCal: val });
    }, // endingComparedChanged
    refreshPage() {
      this.$emit('refreshPage');
    }, // refreshPage
    submitDate() {
      const dateFilter = {
        startDate: format(this.selectedPeriod.start, 'yyyy-MM-dd'),
        endDate: format(this.selectedPeriod.end, 'yyyy-MM-dd'),
        compareStartDate: format(this.comparedPeriod.start, 'yyyy-MM-dd'),
        compareEndDate: format(this.comparedPeriod.end, 'yyyy-MM-dd')
      };
      this.setdatefilter(dateFilter);
      this.setCalendarDatesToStoreCal({selectedOption: this.dateOptionsSelectedModel.value, comparedOption: this.dateOptionsComparedModel.value, selectedPeriod: this.selectedPeriod, comparedPeriod: this.comparedPeriod})
      
      this.hide();
      
      // this.refreshPage();
    }, // submitDate
    hide() {
      this.$refs.periodFilter1.hide();
    },
  
    formatDate(date) {
       if (!date) return null;
      let newDate = date.toISOString().substr(0, 10);
      const [year, month, day] = newDate.split('-');
      return `${year}-${month}-${day}`;
    },
    getComparedDate(date) {
      if (date && this.compareDates) {
        let dateObj = this.compareDates.filter(dat => dat.date === date);
        if (dateObj.length > 0) {
          return new Date(dateObj[0].comparedDate);
        } else {
          return '';
        }
      }
    },
    dropDownToggled(val) {
      if(val == 2) {
        this.hide()
      }
      // setTimeout(() => {
      //   document.querySelector(".calender-card .vc-weeks .vc-highlight.vc-bg-blue-600")?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      // }, 1000);
    },
  } // methods
}; // export default
